// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import EventDetail from './EventDetail';
import UserDetails from './UserDetails'; // Import the new component
import PaymentSuccess from './PaymentSuccess';
import BlogPostDetail from './BlogPostDetail';
import OnboardingReturnPage from './OnboardingReturnPage';
import OnboardingRefreshPage from './OnboardingRefreshPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/users/:id" element={<UserDetails />} /> {/* New Route */}
        <Route path="/donate/success" element={<PaymentSuccess />} />
        <Route path="/blog/:id" element={<BlogPostDetail />} />
	<Route path="/onboarding/return" element={<OnboardingReturnPage />} />
	<Route path="/onboarding/refresh" element={<OnboardingRefreshPage />} />

      </Routes>
    </div>
  );
}

export default App;

